module.exports = __webpack_public_path__ + "static/img/jxjl3.409f887.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jxjl3.png
// module id = SlZq
// module chunks = 1